<template>
  <div>
    <div class="main">
      <div class="header">
        <div class="left user">
          <el-avatar :size="60" :src="resPicUrl" @error="errorHandler">
            <img src="../../assets/img/morentouxiangicon.png" />
          </el-avatar>
          <div class="teaNickname">{{ resnickname }}</div>
        </div>
        <div class="right caidan">
          <router-link class="navTrain" to="/center/self" tag="div"
            ><i class="iconfont icon-bianji"></i
            ><span>个人资料</span></router-link
          >
          <router-link class="navTrain" to="/center/collection" tag="div"
            ><i class="iconfont icon-qingdan"></i
            ><span>选书清单</span></router-link
          >
          <router-link class="navTrain" to="/center/apply" tag="div">
            <i class="iconfont icon-shenqingliebiao"></i
            ><span>申请样书列表</span></router-link
          >
          <router-link class="navTrain" to="/center/publish" tag="div">
            <i class="iconfont icon-xiaotubiaochuban"></i
            ><span>我要出版</span></router-link
          >
          <router-link class="navTrain" to="/center/liuyan" tag="div">
            <i class="iconfont icon-liuyan"></i
            ><span>回告管理</span></router-link
          >
        </div>
      </div>
      <router-view></router-view>
    </div>
  </div>
</template>
<script>
import { mapMutations, mapState, mapGetters } from 'vuex'
export default {
  computed: {
    ...mapGetters(['resPicUrl', 'resnickname']),
  },
  data() {
    return {
      gotoadmin: 'https://book.51suiyixue.com/',
    }
  },
  methods: {
    errorHandler() {
      return true
    },
    logo() {
      window.open('http://www.maisuiedu.com/')
    },
  },
}
</script>
<style lang="scss">
.header {
  height: 80px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  background-color: #ffffff;
  border-radius: 4px;
  margin-top: 20px;
  margin-bottom: 10px;
}
.user {
  display: flex;
  align-items: center;
  margin-left: 40px;
}
.caidan {
  display: flex;
  align-items: center;
  margin-right: 38px;
}
.maincontent .el-row {
  margin-left: 0px !important;
  margin-right: 0px !important;
}
.maincontent .el-row .main-left {
  padding-left: 0 !important;
  padding-right: 0 !important ;
}
.maincontent .el-col {
  padding-left: 0 !important;
  padding-right: 0 !important ;
}
.maincontent .el-avatar {
  background-color: #f8f8f8 !important;
}
.iconfont {
  font-family: 'iconfont' !important;
  font-size: 18px;
  font-style: normal;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}
.icon-denglu:before {
  content: '\e611';
}
.listNav {
  width: 100%;
  height: 36px;
  background: rgba(237, 234, 231, 1);
  span {
    height: 12px;
    color: rgba(102, 102, 102, 1);
    line-height: 36px;
    margin-right: 5px;
  }
  .home-icon {
    display: inline-block;
    width: 12px;
    height: 12px;
    margin-right: 6px;
    vertical-align: middle;
    padding-bottom: 5px;
    background: url('../../assets/img/home-icon.png') no-repeat 0 0;
  }
  :nth-child(5) {
    color: #0082f0;
  }
}
</style>
<style lang="scss" scoped>
.bg {
  background-color: #ffffff;
  background-repeat: no-repeat;
  background-size: 100% 100%;
  .main {
    background: #f8f8f8;
  }
}

.maincontent {
}
.teaNickname {
  font-size: 14px;
  font-weight: 500;
  color: #666666;
  line-height: 14px;
  margin-left: 10px;
}
.separate {
  height: 10px;
  background-color: rgba(248, 248, 248, 1);
}
.navTrain {
  height: 46px;
  padding-left: 30px;
  color: #666666;
  border-bottom: 1px solid rgba(230, 230, 230, 0.3);
  .personal-icon {
    height: auto;
    max-width: 100%;
    vertical-align: middle;
  }
  span {
    display: inline-block;
    line-height: 46px;
    font-size: 14px;
    margin-left: 12px;
  }
  &:hover span {
    font-size: 14px;
    color: #0082f0;
  }
  &:hover {
    font-size: 14px;
    color: #0082f0;
  }
}
.router-link:hover {
  font-size: 14px;
  color: #0082f0;
}
.router-link-active {
  font-size: 14px;
  color: #0082f0;
}
</style>
